import { createElement } from 'react'

export type TranslatableType = string | JSX.Element
export function isJSX(arg: TranslatableType): arg is JSX.Element {
  return typeof arg !== 'string'
}

export function makeTranslatable(arg: TranslatableType): JSX.Element {
  if (isJSX(arg)) {
    return arg
  } else {
    return createElement('span', {}, arg)
  }
}
